/**
 * 价格 100---》100.00  0.2--->0.20
 */
let formattedPrice = item => {
  if(item){
    item = item;
    let parseF = parseFloat(item);
    if (isNaN(parseF)) {
      return 0.00;
    }
    //金额转化为份，在取整
    let toPoints = Math.round(item*100)/100;
    let toStr = toPoints.toString();
    let retStr = toStr.indexOf('.');
    if (retStr < 0) {
      retStr = toStr.length;
      toStr += '.';
    }
    while (toStr.length <= retStr + 2) {
      toStr += '0';
    }
    return toStr;
  }
}
export {
  formattedPrice
}



// WEBPACK FOOTER //
// ./src/common/filters.js